import React from 'react';
import DocumentCompletedItem from './DocumentCompletedItem/DocumentCompletedItem';
import ActionButtons from './ActionButtons/ActionButtons';
import { DocumentStatus } from './types';

const ReviewTemplatesCard = ({
  jobData,
  onSelectMoreDocuments,
}: {
  jobData: any;
  onSelectMoreDocuments?: () => void;
}) => {
  if (!jobData) return null;

  const templates = (jobData.documents || []).filter(
    (doc: any) => doc.status === DocumentStatus.COMPLETED && doc.template,
  );

  // Don't show the card until at least 1 document is completed
  if (templates.length === 0) return null;

  const activeDocuments = (jobData.documents || []).filter(
    (doc: any) =>
      doc.status === DocumentStatus.PENDING ||
      doc.status === DocumentStatus.PROCESSING,
  );
  const allProcessed = activeDocuments.length === 0;

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-8 max-w-2xl mx-auto flex flex-col gap-8">
      <div>
        <h2 className="text-base font-semibold text-gray-900 m-0 flex items-center gap-2">
          Review Templates
        </h2>
      </div>
      <div>
        <div className="text-sm mb-4">
          Templates have been saved to your word templates library. Here&apos;s
          what you can do next:
        </div>
        <ul className="text-sm space-y-1 list-disc list-inside">
          <li>
            View the template in Word using the Clio Draft Template Builder.
          </li>
          <li>Check the cards and fields that were created are correct.</li>
          <li>Add / correct cards and fields.</li>
        </ul>
      </div>
      <div className="space-y-2">
        {templates.map((doc: any, index: number) => (
          <DocumentCompletedItem
            key={doc.id || `template-${index}`}
            template={doc.template}
            templateName={doc.template?.title || doc.filename}
          />
        ))}
      </div>
      <ActionButtons
        allProcessed={allProcessed}
        onSelectMoreDocuments={onSelectMoreDocuments}
      />
    </div>
  );
};

export default ReviewTemplatesCard;
